module.exports = __webpack_public_path__ + "img/447-78072c.png";